import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '社内リソース不足の中、React Native×GraphQLを採用したアジャイル開発で、WebサービスのiOSアプリ化を実質2か月半でリリース。事前の徹底的な環境構築と毎日の実機検証により、短納期・高品質を両立したSANUのアプリ開発事例です。'

const primaryImage = `${SITE_URL}/images/img/cases/sanu/ogp_sanu.png`

/** HeadMeta と JSON-LD で共有するメタ情報 */
export const sanuPageMeta: PageMeta = {
  title: 'Webサービスを2か月半でアプリ化｜React Nativeアジャイル開発事例 | i3DESIGN',
  description,
  keyword: '事例 実績 アプリ開発 React Native GraphQL',
  image: primaryImage,
  url: `${SITE_URL}/cases/sanu/`,
}

export const sanuSchema = buildCaseStudySchema({
  slug: 'sanu',
  pageTitle: sanuPageMeta.title,
  description: sanuPageMeta.description,
  headline: 'アジャイル開発によりWebサービスのアプリ化を2か月半で実現',
  alternativeHeadline: '株式会社SANU',
  primaryImage,
  images: [primaryImage, `${SITE_URL}/images/img/cases/sanu/mv.webp`],
  clientName: '株式会社SANU',
  breadcrumbLabel: 'アジャイル開発によりWebサービスのアプリ化を2か月半で実現',
})
